<app-top-bar
	[transportId]="store.transport()?.id"
	[module]="TransportModule.COACH_LIST"
	[side]="store.transport()?.side ?? TransportSide.DEPARTURE"
	[buttonsDisabled]="store.transportAction() === TransportAction.ADD"
	[transportName]="store.transport()?.name"
	[kind]="store.transport()?.kind"
	[transportsToLinkNames]="store.transportsToLinkNames()"
	[disableSaveButton]="hasDoubledSlots() || someSlotNumberIsNull() || gotUnassignedTab()"
	[coachListUrl]="store.transport()?.coachListUrl"
	(saveTransportCoachListEvent)="saveCoachList()"
	(resetCoachListEvent)="resetCoachList()"
	(copyCoachListEvent)="copyCoachList()"
>
</app-top-bar>
@if (dataIsLoading()) {
	<div class="w-100 vh-100">
		<app-custom-mat-loader></app-custom-mat-loader>
	</div>
} @else {
	<mat-accordion>
		@for (item of couchGroupedByVehicleAndLevel(); track item.vehicle?.id; let fist = $first; let index = $index) {
			<mat-expansion-panel
				[disabled]="expansionPanelToDisable() === item.type"
				[expanded]="fist"
				(opened)="onRefChange(index)"
			>
				<mat-expansion-panel-header [ngClass]="{ 'bg-danger': item.hasDoubledSlots }">
					<mat-panel-title>
						@if (item.type === CouchGroupByVehicleEnum.UNASSIGNED) {
							Nieprzypisani uczestnicy
						} @else {
							{{ item.vehicle.name }}
							@if (item.type !== CouchGroupByVehicleEnum.SINGLE) {
								{{ item.type === CouchGroupByVehicleEnum.AFTER ? 'po przesiadce' : 'przed przesiadką' }}
							}
						}
					</mat-panel-title>
				</mat-expansion-panel-header>

				@if (item.type === CouchGroupByVehicleEnum.UNASSIGNED) {
					<app-transport-coach-table
						[dataSource]="item.slots"
						[highlightedSlotIds]="highlightedSlotIds()"
						[selectedDataToUpdate]="selectedDataToUpdate()"
						[displayedColumns]="unassignedDisplayedColumns"
						[transportSide]="store.transport()?.side"
						(chooseSlotChange)="chooseSlot($event)"
						(onSortChange)="onSort($event, index)"
						(rowsReady)="onRowsReady($event, index)"
					>
					</app-transport-coach-table>
				} @else {
					<div class="d-flex justify-content-between align-items-start">
						<div #busRef style="justify-items: center" class="w-25">
							@if (item.floors.length === 1) {
								<app-bus
									[chosenSeats]="chosenSeats()[index]"
									[bus]="item.layout"
									(seatClick)="chooseSeat($event, item)"
								></app-bus>
							} @else {
								<mat-tab-group (selectedTabChange)="onRefChange(index)" animationDuration="0ms">
									@for (tab of item.floors; track tab.level) {
										<mat-tab [label]="'Piętro ' + tab.level">
											<div class="mt-3">
												<app-bus
													[chosenSeats]="chosenSeats()[index]"
													[bus]="tab.layout"
													(seatClick)="chooseSeat($event, item)"
												></app-bus>
											</div>
										</mat-tab>
									}
								</mat-tab-group>
							}
						</div>
						<section #sectionRef class="coach-container" (mouseleave)="onMouseLeaveSection()">
							<app-transport-coach-table
								[dataSource]="item.slots"
								[highlightedSlotIds]="highlightedSlotIds()"
								[selectedDataToUpdate]="selectedDataToUpdate()"
								[displayedColumns]="displayedColumns()"
								[transportSide]="store.transport()?.side"
								(chooseSlotChange)="chooseSlot($event)"
								(onSortChange)="onSort($event, index)"
								(removeSeatEmit)="removeSeat($event)"
								(rowsReady)="onRowsReady($event, index)"
							>
							</app-transport-coach-table>
						</section>
					</div>
				}
			</mat-expansion-panel>
		}
	</mat-accordion>
}
